/* 

Copyright© Celligence International, LLC - 2024

This software program is protected by copyright laws and is the property of
Celligence International, LLC (Celligence). Any unauthorized reproduction,
distribution, modification, or public display of this program, without the
explicit permission of Celligence is strictly prohibited. If you have gained
access to this program without the expressed approval of Celligence report
the incident to legal@celligence.com.

*/

//Jacques Bega
//hook that grabs list of companies given certain business type; entries returned use their primary address information
//this hook can be expanded on as needed
import { QueryFunctionContext, useQuery } from '@tanstack/react-query';
import { fetchCompCodes } from '../queryFunctions';

const useCompCodes = (businessType: string[], token: string) => {
  return useQuery({
    queryKey: [businessType, token, 'compCodes'],
    queryFn: ({ signal }: QueryFunctionContext) => fetchCompCodes(signal, token, businessType),
    refetchOnWindowFocus: false,
  });
};

export default useCompCodes;
